// extracted by mini-css-extract-plugin
module.exports = {"root":"Param_root__2UV1F","valueCheck":"Param_valueCheck__2Vy9X","valueCross":"Param_valueCross__2PxdW"};